import React from "react";
import GameData from "../../../gameplay/model/GameData";
import image from "../../../images/gameplay_ui/illustrations/dispetcher.png";
import {DISPETCHER_COLOR} from "../GameStyleUI";
import GameButtonWithIcon from "../GameButtonWithIcon";
import CurrencyCard from "../GeneralCards/CurrencyCard";
import brigade_icon from "../../../images/gameplay_ui/icons/brigades_icon.svg";
import brigade_chips_icon from "../../../images/gameplay_ui/icons/brigade_chips_icon.svg";
import BuyWorkhourPopup from "../Popups/BuyWorkhourPopup";

export default class StationPanel_DispetcherCard extends React.Component {
    constructor(props) {
        super(props);
        this.popup = null;
    }

    render() {
        if (!this.props.canShow)
            this.popup = null;

        let dispetcher = GameData.CurrentGame.getDispetcher();
        let mainStyle = {
            position: "relative",
            width: "181px",
            height: "50px",
            background: "rgba(0, 0, 0, 0.5)",
            borderRadius: "3px",
            justifySelf: "end"
        }
        let container = {
            padding: "5px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between"
        }
        let colors = DISPETCHER_COLOR;
        let value = dispetcher.brigadesChips - GameData.CurrentGame.currentTrains.length;
        value = value < 0 ? 0 : value;
        value += dispetcher.additionalChips + GameData.CurrentGame.getRentedBrigades("dispetcher", 0) * 4;
        return <div style={mainStyle}>
            <div style={{position: "absolute", bottom: "60px"}}>
                {this.props.canShow && this.popup}
            </div>
            <div style={container}>
                <img src={image} title={"Диспетчерская"} alt={"icon"}/>
                <CurrencyCard
                    title={"Диспетчерские бригады"}
                    icon={brigade_icon}
                    value={dispetcher.brigades + GameData.CurrentGame.getRentedBrigades("dispetcher", 0)}
                    size={20}
                    fontSize={20}
                />
                <GameButtonWithIcon
                    tooltip={"Трудозатраты"}
                    colorStart={colors[0]}
                    colorEnd={colors[1]}
                    icon={brigade_chips_icon}
                    width={58}
                    height={30}
                    title={(value < 0 ? 0 : value)}
                    style={{
                        marginRight: "5px"
                    }}
                    onClick={() => {
                        this.popup = this.popup ? null : <BuyWorkhourPopup
                            id={0}
                            parent={this}
                            teamID={this.props.teamID}
                            type={"dispetcher"}
                            brigades={dispetcher.brigades}
                            additionalChips={dispetcher.additionalChips}
                            onClose={() => {this.popup = null; this.props.updatePopup(5)}}
                        />;

                        this.props.updatePopup(5);

                        this.forceUpdate();

                    }}
                />
            </div>
        </div>
    }
}
